import { createAction } from 'typesafe-actions';
import type { ActionType } from 'typesafe-actions';

import type { ApplicationState } from './types';

export const HYDRATE = '@@HYDRATE' as const;

export const RESET_STORE = 'RESET_STORE';

export const nextHydrate = createAction(HYDRATE)<ApplicationState>();
export const resetStore = createAction(RESET_STORE)<ApplicationState>();

export type HydrateAction = ActionType<typeof nextHydrate>;

export interface ResetStoreAction {
  type: 'RESET_STORE';
}

export type GlobalAction = HydrateAction | ResetStoreAction;
